import { LanderV2CampaignConfig } from "../Campaigns/Schemas/LanderV2/types";

const headlineKeywordParams = ["utm_keyword", "vt_keyword", "keyword", "utm_term", "vt_term", "term"];

function normalizeKeyword(value: string) {
  return value.toLowerCase().trim().replace(/\s+/g, " ");
}

function getHeadlineKeyword(search: string) {
  const params = new URLSearchParams(search);
  const lowerCaseParams = new Map<string, string>();

  params.forEach((value, key) => {
    lowerCaseParams.set(key.toLowerCase(), value);
  });

  for (const key of headlineKeywordParams) {
    const value = lowerCaseParams.get(key);
    if (value?.trim()) {
      return normalizeKeyword(value);
    }
  }

  return "";
}

export function resolveLanderV2Headline(campaign: LanderV2CampaignConfig, search: string) {
  const keyword = getHeadlineKeyword(search);
  const fallback = {
    heading: campaign.heading,
    subheading: campaign.subheading,
  };

  if (!keyword || !campaign.headlineVariants?.length) {
    return fallback;
  }

  const matchedVariant = campaign.headlineVariants.find((variant) =>
    variant.keywords.some((candidate) => keyword.includes(normalizeKeyword(candidate)))
  );

  return matchedVariant
    ? {
        heading: matchedVariant.heading,
        subheading: matchedVariant.subheading,
      }
    : fallback;
}
